import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { InvoiceTypeConstants } from '../common/InvoiceType';

@Injectable({
  providedIn: 'root'
})
export class InvoiceTypeValidatorService {
  /**
   * Mirrors the backend's CustomerValidationCommand: the invoice type is fully
   * determined by the retailer / small-business flags — a retailer without the
   * Kleinunternehmerregelung (§19 UStG) must invoice net, everyone else gross.
   */
  public static deriveInvoiceType(isRetailer: boolean, smallBusinessP19UStG: boolean): number {
    return isRetailer && !smallBusinessP19UStG
      ? InvoiceTypeConstants.net
      : InvoiceTypeConstants.gross;
  }

  public InvoiceTypeValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const isRetailer = !!control.get('isRetailer')?.value;
      const smallBusinessP19UStG = !!control.get('smallBusinessP19UStG')?.value;
      const invoiceType = control.get('selectedInvoiceType')?.value;

      const errors: ValidationErrors = {};

      if (smallBusinessP19UStG && !isRetailer) {
        errors['smallBusinessRequiresRetailer'] = true;
      }

      const requiredInvoiceType = InvoiceTypeValidatorService.deriveInvoiceType(
        isRetailer,
        smallBusinessP19UStG
      );
      if (invoiceType != null && invoiceType !== requiredInvoiceType) {
        if (requiredInvoiceType === InvoiceTypeConstants.net) {
          errors['invoiceTypeMustBeNet'] = true;
        } else {
          errors['invoiceTypeMustBeGross'] = true;
        }
      }

      return Object.keys(errors).length ? errors : null;
    };
  }
}
